module.exports = __webpack_public_path__ + "img/global.67257243.svg";